import { LatLngTuple } from "leaflet";
import { IPartner } from "../types/entities";

// EN: Parse coordinates from environment variable string "lat,lng"
// PL: Parsuj współrzędne ze zmiennej środowiskowej "lat,lng"
const coordsString = import.meta.env.VITE_RESTAURANT_COORDS || "51.1097,17.0322";
const coordsArray = coordsString.split(",").map((s: string) => Number(s.trim()));

export const openingHours = {
    takeaway: {
      start: 9,
      end: 23,
      display: "9:00 - 23:00",
    },
    delivery: {
      start: 11,
      end: 22,
      display: "11:00 - 22:00",
    },
    restaurant: {
      start: 12,
      end: 23,
      display: "12:00 - 23:00",
    },
};

// EN: Helper to check if restaurant is currently open based on restaurant opening hours
export const isRestaurantOpen = (): boolean => {
  const currentHour = new Date().getHours();
  return currentHour >= openingHours.restaurant.start && currentHour < openingHours.restaurant.end;
};

const partners: IPartner[] = [
  { id: 1, name: "Glovo", url: "https://glovoapp.com/pl/wro/store/restauracja-r-ja/", img: "/images/partners/glovo.png" },
  { id: 2, name: "Wolt", url: "https://wolt.com/pl/pol/wroclaw/restaurant/rstauracja-r-ja", img: "/images/partners/wolt.png" },
  { id: 3, name: "Pyszne.pl", url: "https://www.pyszne.pl/menu/restauracja-r-ja", img: "/images/partners/pyszne.png" },
  { id: 4, name: "Uber Eats", url: "https://www.ubereats.com/pl/store/restauracja-r-ja/example-id", img: "/images/partners/uber.png" },

];

export const restaurantSettings = {
  name: import.meta.env.VITE_RESTAURANT_NAME || "Restauracja R-JA.pl",
  address: import.meta.env.VITE_RESTAURANT_ADDRESS || "Rynek 1, 50-106 Wrocław",
  city: import.meta.env.VITE_RESTAURANT_CITY || "Wrocław",
  fullAddress: `${import.meta.env.VITE_RESTAURANT_ADDRESS || "Rynek 1, 50-106 Wrocław"}, ${import.meta.env.VITE_RESTAURANT_CITY || "Wrocław"}`,
  phone: import.meta.env.VITE_RESTAURANT_PHONE || "+48 123 456 789",
  phoneRaw: (import.meta.env.VITE_RESTAURANT_PHONE || "+48123456789").replace(/\s+/g, ""),
  email: import.meta.env.VITE_RESTAURANT_EMAIL || "kontakt@r-ja.pl",
  social: {
    instagram: import.meta.env.VITE_RESTAURANT_INSTAGRAM || "https://instagram.com",
    facebook: import.meta.env.VITE_RESTAURANT_FACEBOOK || "https://facebook.com",
  },
  coords: [coordsArray[0], coordsArray[1]] as LatLngTuple,
  deliveryRadius: Number(import.meta.env.VITE_DELIVERY_RADIUS_METERS) || 1000,
  openingHours,
  partners,
};